import React, { Fragment } from 'react'
import { Form } from 'react-bootstrap'
import OrderSummary from '../Cart/OrderSummary'
import SubsOrderSummary from './SubsOrderSummary'

const SubsCheckout = () => {
    return (
        <Fragment>
            <div className="container my-5">
                <div className="row py-5 justify-content-between">

                    <div className="col-lg-6">
                        <h5 className='mb-4'>Billing Detail</h5>

                        <Form className='row'>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="First Name" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Last Name" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="Email" className='border-0' placeholder="Email" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Phone" />
                            </Form.Group>


                        </Form>


                        <hr />

                        <div className="col-auto">
                            <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                <Form.Check type="checkbox" label="By Clicking, you agree to our Terms & conditions and Privacy Policy" />
                            </Form.Group>
                        </div>



                        <h5 className='mb-4 mt-5'>Add Payment Detail</h5>

                        <Form className='row'>
                            <Form.Group className="mb-3 col-lg-12" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Name on card" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-12" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Card Number" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="CVC" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="Email" className='border-0' placeholder="MM/YY" />
                            </Form.Group>

                            <div>
                                <button className='btn btn-danger w-100'>
                                    Pay now
                                </button>
                            </div>
                        </Form>

                    </div>

                    <div className="col-lg-4">
                        <SubsOrderSummary />
                    </div>
                </div>
            </div>

        </Fragment>
    )
}

export default SubsCheckout